<!--  -->
<template>
  <div class="content">
    <!-- banner -->
    <div class="banner">
      <img @click="jump" src="../../assets/img/serve/banner.png" alt="" />
    </div>
    <!-- 服务项目 -->
    <div class="serve card" v-if="false">
      <Link text="我们的服务项目" />

      <div class="list">
        <div class="li" v-for="(item, index) in list" :key="index" :style="item.bg">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="text">
            <div class="text_li" v-for="(items, indexs) in item.text" :key="indexs">
              {{ items }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 精选服务案例 -->
    <div class="case">
      <div class="card">
        <Link text="精选服务案例" />
        <div class="nav">
          <div class="nav_li" v-for="(item, index) in nav_list" :key="index" :class="current == index ? 'active' : ''"
            @mouseenter="nav_current(index)" @click="nav_current(index)">
            {{ item.text }}
          </div>
        </div>
        <!-- 图片 -->
        <div class="img_list">
          <div :style="current == 1 ? '' : ' '" class="img_li" v-for="(item, index) in list_img[current].img"
            :key="index" @click="bcolor(index)" @mouseenter="bcolor(index)" @mouseleave="wcolor">
            <div v-if="
              current == 0 ||
              current == 3 ||
              current == 4 ||
              current == 5 ||
              current == 8
            ">
              <div @click="topUrl(index, current)" :class="current == 0 || current == 4 || current == 5 || current == 8
                ? 'img_div'
                : ''
                ">
                <img :class="current == 0 || current == 4 || current == 5 || current == 8
                  ? 'img'
                  : ''
                  " :src="item.url" alt="" />
              </div>

              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.text }}</div>
            </div>
            <div v-if="current == 1">
              <div @click="topUrl(index, current)">
                <img class="er_img_er" :src="item.url" alt="" />
              </div>

              <div class="title">{{ item.title }}</div>
              <div class="text">{{ item.text }}</div>
            </div>
            <div v-if="current == 2">
              <a :href="item.a_url" target="_bank">
                <img class="" :src="item.url" alt="" />
                <div class="title">{{ item.title }}</div>
                <div class="text">{{ item.text }}</div>
              </a>
            </div>
            <div v-if="current == 6">
              <div class="img_div" @mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)" v-if="item.img_show">
                <video muted :id="'my-player' + index" controls="controls" class="video6" ref="video">
                  <source :src="item.url" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div class="img_div" @click="play_video(index)" v-if="item.img_show == false">
                <img :src="item.img" alt="" />
              </div>

              <div class="title">{{ item.title }}</div>
              <div class="text">
                {{ item.text }}
              </div>
            </div>
            <div v-if="current == 7">
              <div class="imgs" @mouseover="mouseOver(index)" @mouseleave="mouseLeave(index)" v-if="item.img_show">
                <video muted :id="'my-player' + index" class="video7" controls="controls" ref="video">
                  <source :src="item.url" type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <div class="imgs" @click="play_video(index)" v-if="item.img_show == false">
                <img :src="item.img" alt="" />
              </div>
              <div class="title">{{ item.title }}</div>
              <div class="text">
                {{ item.text }}
              </div>
            </div>
            <!-- 小程序二维码 -->
            <div :class="current == 1 ? 'img_er' : current == 3 ? 'img_ers' : ''" v-show="(current == 1 && index == er_current) ||
              (current == 3 && index == er_current)
              ">
              <div :class="current == 1 ? 'er_bg' : current == 3 ? 'er_bgs' : ''">
                <div class="er_text">
                  <img :class="current == 1 ? 'er_img' : current == 3 ? 'er_imgs' : ''" :src="item.er" alt="" />

                  <div class="text">请使用微信扫一扫查看</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Link from "../../components/all_text.vue";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Link,
  },
  data() {
    //这里存放数据
    return {
      list: [
        {
          bg:
            " background: url(" +
            require("../../assets/img/serve/1.png") +
            "); no-repeat; background-size: 100% 100%;",
          title: "技术服务",
          text: ["软件定制开发", "小程序开发", "企业网站建设", "商城建设"],
        },
        {
          bg:
            " background: url(" +
            require("../../assets/img/serve/2.png") +
            ");no-repeat; background-size: 100% 100%;",
          title: "设计服务",
          text: ["UI设计", "logo设计", "美工设计", "平面设计"],
        },
        {
          bg:
            " background: url(" +
            require("../../assets/img/serve/3.png") +
            ");no-repeat; background-size: 100% 100%;",
          title: "视频服务",
          text: ["宣传片", "短视频", "视频剪辑", "PPT制作"],
        },
      ],
      // 案例展示
      nav_list: [
        {
          id: 0,
          text: "软件定制开发",
        },
        {
          id: 0,
          text: "小程序开发",
        },
        {
          id: 0,
          text: "企业网站建设",
        },
        {
          id: 0,
          text: "商城建设",
        },
        {
          id: 0,
          text: "logo设计",
        },
        {
          id: 0,
          text: "平面设计",
        },
        {
          id: 0,
          text: "视频制作",
        },
        {
          id: 0,
          text: "短视频制作",
        },
        {
          id: 0,
          text: "PPT制作",
        },
      ],
      current: 0,
      er_current: 0,
      list_img: [
        {
          img: [
            {
              url: require("../../assets/img/serve/软件定制开发/1.png"),
              title: "货运教学平台",
              text: "后台系统",
              a_url: "",
            },
            {
              url: require("../../assets/img/serve/软件定制开发/2.png"),
              title: "跨境电商系统",
              text: "后台系统",
              a_url: "",
            },
            {
              url: require("../../assets/img/serve/软件定制开发/3.png"),
              title: "周期购电商系统",
              text: "后台系统",
              a_url: "",
            },
          ],
        },
        {
          img: [
            {
              url: require("../../assets/img/serve/小程序/1.png"),
              er: require("../../assets/img/serve/小程序/1.jpg"),
              title: "浩通速运",
              text: "微信小程序",
            },
            {
              url: require("../../assets/img/serve/小程序/2.png"),
              er: require("../../assets/img/serve/小程序/2.jpg"),
              title: "浩通物流追踪",
              text: "微信小程序",
            },
            {
              url: require("../../assets/img/serve/小程序/3.png"),
              er: require("../../assets/img/serve/小程序/3.jpg"),
              title: "浩通名片",
              text: "微信小程序",
            },
            {
              url: require("../../assets/img/serve/小程序/4.png"),
              er: require("../../assets/img/serve/小程序/4.jpg"),
              title: "货运现场",
              text: "微信小程序",
            },
          ],
        },
        {
          img: [
            {
              url: require("../../assets/img/serve/企业网站/1.png"),
              title: "浩通国际货运代理有限公司",
              text: "官方网站",
              a_url: "http://www.hital.com/",
            },
            {
              url: require("../../assets/img/serve/企业网站/2.png"),
              title: "生易圈教育咨询有限公司",
              text: "官方网站",
              a_url: "http://www.hital.com/",
            },
          ],
        },
        {
          img: [
            {
              url: require("../../assets/img/serve/商城/1.png"),
              er: require("../../assets/img/serve/商城/1.jpg"),
              title: "澳洲诺科鲜奶商城",
              text: "微信小程序",
            },
          ],
        },
        {
          img: [
            {
              url: require("../../assets/img/serve/logo/1.png"),
              title: "欣福城环境科技有限公司",
              text: "LOGO设计",
            },
            {
              url: require("../../assets/img/serve/logo/2.png"),
              title: "上海希光进出口有限公司",
              text: "LOGO设计",
            },
            {
              url: require("../../assets/img/serve/logo/3.png"),
              title: "生意通湖南有限公司",
              text: "LOGO设计",
            },
          ],
        },
        {
          img: [
            {
              url: require("../../assets/img/serve/平面/1.png"),
              title: "货运教学平台宣传",
              text: "两折页设计",
            },
            {
              url: require("../../assets/img/serve/平面/2.png"),
              title: "供应链口罩采购宣传",
              text: "两折页设计",
            },
            {
              url: require("../../assets/img/serve/平面/3.png"),
              title: "供应链纸吸管宣传",
              text: "三折页设计",
            },
            {
              url: require("../../assets/img/serve/平面/4.png"),
              title: "货运教学平台宣传",
              text: "展板设计",
            },
            {
              url: require("../../assets/img/serve/平面/5.png"),
              title: "供应链口罩采购宣传",
              text: "展板设计",
            },
            {
              url: require("../../assets/img/serve/平面/6.png"),
              title: "供应链产品宣传",
              text: "海报设计",
            },
          ],
        },

        // 多视频
        {
          img: [
            {
              url: "http://www.hitalgroup.com/mp4/1.mp4",
              title: "浩通国际宣传视频",
              text: "视频剪辑制作",
              img: require("../../assets/img/1.png"),
              img_show: false,
            },
            // {
            //   url: require("../../assets/img/serve/视频/2.mp4"),
            //   title: "供应链线上广交会宣传视频",
            //   text: "视频剪辑制作",
            //   img: require("../../assets/img/2.png"),
            //   img_show: false,
            // },
            {
              url: "http://www.hitalgroup.com/mp4/2.mp4",
              title: "澳洲诺科鲜奶宣传推广",
              text: "视频剪辑制作",
              img: require("../../assets/img/3.png"),
              img_show: false,
            },
            {
              url: "http://www.hitalgroup.com/mp4/3.mp4",
              title: "霞凝港开单流程宣传",
              text: "视频剪辑制作",
              img: require("../../assets/img/4.png"),
              img_show: false,
            },
            {
              url: "http://www.hitalgroup.com/mp4/4.mp4",
              title: "浩通国际抗疫援鄂纪实",
              text: "视频剪辑制作",
              img: require("../../assets/img/5.png"),
              img_show: false,
            },
            // {
            //   url: require("../../assets/img/serve/视频/6.mp4"),
            //   title: "仓库管理系统操作教程",
            //   text: "视频剪辑制作",
            //   img: require("../../assets/img/6.png"),
            //   img_show: false,
            // },
            {
              url: "http://www.hitalgroup.com/mp4/5.mp4",
              title: "湖南现代物流职业技术学院",
              text: "视频剪辑制作",
              img: require("../../assets/img/7.png"),
              img_show: false,
            },
            {
              url: "http://www.hitalgroup.com/mp4/6.mp4",
              title: "黄花机场货物进出运输教宣",
              text: "视频剪辑制作",
              img: require("../../assets/img/8.png"),
              img_show: false,
            },
          ],
        },
        // 视频
        {
          img: [
            {
              url: require("../../assets/img/serve/短视频/wl.mp4"),
              title: "浩通物流追踪小程序操作教程",
              text: "短视频制作",
              img: require("../../assets/img/9.png"),
              img_show: false,
            },
          ],
        },
        {
          img: [
            {
              url: require("../../assets/img/serve/PPT/1.png"),
              title: "浩通集团六五战略规划",
              text: "PPT美化",
            },
            {
              url: require("../../assets/img/serve/PPT/2.png"),
              title: "浩通信息化发展与战略",
              text: "PPT制作",
            },
            {
              url: require("../../assets/img/serve/PPT/3.png"),
              title: "外综服平台项目计划",
              text: "PPT美化",
            },
            {
              url: require("../../assets/img/serve/PPT/4.png"),
              title: "仓储运输管理系统",
              text: "PPT制作",
            },
            {
              url: require("../../assets/img/serve/PPT/5.png"),
              title: "国内陆路运输项目方案",
              text: "PPT美化",
            },
          ],
        },
      ],
      autoplay: false, //视频
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 底部
    jump(index) {
      let jump = document.getElementById("d_jump");
      // 获取需要滚动的距离
      let total = jump.offsetTop;
      console.log(jump.offsetTop);

      // Chrome
      document.body.scrollTop = total;
      // Firefox
      document.documentElement.scrollTop = total;
      // Safari
      window.pageYOffset = total;
    },
    // nav
    nav_current(e) {
      this.current = e;
      this.$forceUpdate();
      console.log(e);
    },
    // 显示二维码
    bcolor(e) {
      this.er_current = e;
    },
    wcolor() {
      this.er_current = -1;
    },
    mouseOver(index) {
      var id = "my-player" + index;
      $("#" + id)[0].play();
      console.log(index);
    },
    mouseLeave(index) {
      var id = "my-player" + index;
      $("#" + id)[0].pause();
      this.list_img[this.current].img[index].img_show =
        !this.list_img[this.current].img[index].img_show;
    },
    play_video(index) {
      var id = "my-player" + index;
      this.list_img[this.current].img[index].img_show =
        !this.list_img[this.current].img[index].img_show;
      $("#" + id)[0].play();
    },
    //跳转
    topUrl(index, current) {
      console.log(index, current);
      if (current == 0) {
        if (index == 0) {
          this.$router.push("/Service_education");

          this.$store.state.current = 1;

          localStorage.setItem("current", 1);
          window.sessionStorage.setItem(
            'text',
            '货运教学平台能让学生快速掌握线上货物实操技能'
          )
          window.sessionStorage.setItem(
            'top_text',
            '提交信息申请免费体验，体验真实案例货物运输线上实操功能'
          )
          window.sessionStorage.setItem(
            'fot_text',
            '您提交的信息仅限于申请货运教学平台的免费体验资格，您的信息将会被严格保密！'
          )

          window.dispatchEvent(new Event('sessionStorageChange'))
        } else if (index == 1) {
          this.$router.push("/Shop");

          this.$store.state.current = 1;

          localStorage.setItem("current", 1);
          window.sessionStorage.setItem(
            'text',
            '跨境电商系统'
          )
          window.sessionStorage.setItem(
            'top_text',
            '提交信息申请免费体验，体验智能数据核对'
          )
          window.sessionStorage.setItem(
            'fot_text',
            '您提交的信息仅限于申请跨境电商系统的免费体验资格，您的信息将会被严格保密！'
          )

          window.dispatchEvent(new Event('sessionStorageChange'))
        } else {
          this.$router.push("/Cycle");

          this.$store.state.current = 1;
          localStorage.setItem("current", 1);
          window.sessionStorage.setItem(
            'text',
            '周期购电商系统锁定客户，提高客单价值'
          )
          window.sessionStorage.setItem(
            'top_text',
            '提交信息申请免费体验，体验周期购模式商品管理平台'
          )
          window.sessionStorage.setItem(
            'fot_text',
            '您提交的信息仅限于申请周期购电商系统的免费体验资格，您的信息将会被严格保密！'
          )

          window.dispatchEvent(new Event('sessionStorageChange'))
        }
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    //   $(".ico").hover(function(){
    //   $(".ico").hide();
    // 	$("#my-player")[0].play();
    // },()=>{
    //     $(".ico").show();
    // 	$("#my-player")[0].pause();
    // })
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang='less'>
@import url(../About/pc);
</style>